import React, { useState } from 'react';
import { FeedbackMessages } from '../../../../helpers/enums/feedback.ts';
import { feedbackIcons } from '../../../../../../../../apps/admin/src/common/functions/feedbackIcons.ts';
import { GenericPopup, MultilineTextBox, ButtonTheme } from '@apply/components';

export interface IFeedbackModalV2Options {
    isOpen: boolean;
    confirmFeedbackCallback(category: number, type: number, comment: string): void;
    cancelFeedbackCallback(): void;
}

export const FeedbackModalV2 = ({
    isOpen,
    confirmFeedbackCallback,
    cancelFeedbackCallback,
}: IFeedbackModalV2Options): React.ReactElement => {
    const [comment, set_comment] = useState('');
    const [category, set_category] = useState(0);
    const [feedbackStatement, set_feedbackStatement] = useState('Comments (Optional)');
    const [type] = useState(1); // Currently, only one FeedbackType exists (Draw feedback).
    const [disableButton, set_disableButton] = useState(false);

    const _handleConfirm = () => {
        set_disableButton(true);
        confirmFeedbackCallback(category, type, comment);
    };
    const _handleCancel = () => cancelFeedbackCallback();

    const [selectedIcon, set_selectedIcon] = useState<number | null>(0);

    const actionButtons = [
        {
            id: 'cancelFeedbackButton',
            theme: ButtonTheme.LinkBlue,
            disabled: false,
            children: 'Cancel',
            width: '150px',
            handleClick: _handleCancel,
        },
        {
            id: 'submitFeedbackButton',
            theme: ButtonTheme.Primary,
            disabled: category == 0 || disableButton,
            children: 'Submit',
            width: '200px',
            handleClick: _handleConfirm,
        },
    ];

    const handleClick = (id: number) => {
        set_selectedIcon(id);
        set_category(id);
        switch (id) {
            case 1:
                set_feedbackStatement(FeedbackMessages.Great);
                return;
            case 2:
                set_feedbackStatement(FeedbackMessages.Good);
                return;
            case 3:
                set_feedbackStatement(FeedbackMessages.Neutral);
                return;
            case 4:
                set_feedbackStatement(FeedbackMessages.Negative);
                return;
            case 5:
                set_feedbackStatement(FeedbackMessages.VeryNegative);
                return;
            default:
                return;
        }
    };

    return (
        <GenericPopup
            id='feedbackPopup'
            isOpen={isOpen}
            actionButtons={actionButtons}
            handleClose={_handleCancel}
            aria-labelledby='alert-dialog-title'
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title='Success! Your Draw Request has been Submitted!'
            width='650px'
            height='450px'
            maxWidth='90%'
            maxHeight='70%'
            buttonAlignment='right'
            wrapTitle={true}
        >
            <div className='feedback'>
                <h5>Rate Your Experience</h5>
                <div className='feedback-icons'>
                    {feedbackIcons.map(({ id, imageName, title, className }) => (
                        <div
                            key={id}
                            onClick={() => handleClick(id)}
                            title={title}
                            className={`feedback-icon-containerbutton ${className} ${selectedIcon === id ? 'active' : 'inactive'}`}
                        >
                            <div className='feedback-icon'>
                                <img
                                    src={`/assets/img/${imageName}`}
                                    alt={title}
                                    className='feedback-icon-image'
                                />
                            </div>
                        </div>
                    ))}
                </div>
                <div className='columns'>
                    <MultilineTextBox
                        label={feedbackStatement}
                        value={comment}
                        required={false}
                        maxLength={400}
                        onChange={set_comment}
                        height={'100px'}
                    />
                </div>
            </div>
        </GenericPopup>
    );
};
